import { render } from "./MessContent.vue?vue&type=template&id=89e1fc74&scoped=true"
import script from "./MessContent.vue?vue&type=script&lang=js"
export * from "./MessContent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e1fc74"]])

export default __exports__